<template>
    <div class="">
          <div class="alert-notification">
            <p> Important Update: Changes in Payment Methods for Virtual Account Holders  <span class="cursor-pointer" data-toggle="modal" data-target="#absenteesModal">&nbsp;<u>View Details.</u></span></p>
          </div>
        <div class="page-top mb-1 mb-3 clearfix">
            <h1 class="float-left">Payment Slip </h1>
            <!-- <a href="javascript:void(0)" class="btn btn-primary float-right" id="submitForm" v-on:click="submitForm"> Submit </a> -->

        </div>

      <div class="page-top mb-1 mb-3 clearfix">
        <ul class="nav nav-tabs nav-tabsv-1 float-left" id="myTab" role="tablist">
          <li class="nav-item" v-if="paymentSlips">
            <a class="nav-link active" id="upload-tab" @click="reloadList('upload')" data-toggle="tab" href="#upload" role="tab" aria-controls="upload" aria-selected="true">Upload Payment Invoice</a>
          </li>
          <li class="nav-item" v-if="viewPaymentSlips">
            <a class="nav-link" id="history-tab"  @click="reloadList('history')" data-toggle="tab" href="#history" role="tab" aria-controls="history" aria-selected="false"  >Payment Invoice History</a>
          </li>
        </ul>
      </div>

      <div class="tab-content" id="myTabContent">

        <div v-if="paymentSlips" class="tab-pane fade show active" id="upload" role="tabpanel" aria-labelledby="upload-tab">
          <div class="global-main">
            <div class="global-inner my-account-inner">
              <!-- <p class="mb-3"> Please upload the bank deposit slip. </p> -->
              <form id="paymentInvoice">
                <div class="form-group">
                  <label class="label block-label"> Bank <em class="required">*</em> </label>
                  <select v-model="form.bank" name="bank" autocomplete="off" class="form-control selectpicker custom-select2">
                    <option value="MEEZAN" selected>MEEZAN</option>
                    <option value="ALFALAH">ALFALAH</option>
                    <option value="FINCA">FINCA</option>
                    <option value="EASYPAISA">EASYPAISA</option>
                  </select>
                  <has-error :form="form" field="bank"></has-error>
                </div>
                <div class="form-group">
                  <label class="label block-label">Deposited Via <em class="required">*</em> </label>
                  <select v-model="form.via" name="via" autocomplete="off" class="form-control selectpicker custom-select2">
                    <option value="IBFT">IBFT</option>
                    <option value="CHECKDEPOSIT">Check  Deposit</option>
                    <option value="RTGS">RTGS</option>
                    <option value="CASHDEPOSIT">Cash Deposit</option>
                  </select>
                  <has-error :form="form" field="via"></has-error>
                </div>
                <div class="form-group">
                  <label class="label block-label"> Deposited Date <em class="required">*</em> </label>
                  <datepicker name="deposit_date" input-class="datepicker"  :bootstrap-styling="true" :clear-button="true" placeholder="Deposit Date" v-model="form.deposit_date" ></datepicker>
                  <has-error :form="form" field="deposit_date"></has-error>
                </div>

                <div class="form-group">
                  <label class="label block-label">Amount:  <em class="required">*</em> </label>
                  <input type="number" class="form-control" name="amount" v-model="form.amount" :class="{ 'is-invalid': form.errors.has('amount') }" />
                  <has-error :form="form" field="amount"></has-error>
                </div>
                <div class="update-profile">
                  <div class="form-group upload-img-inner">
                    <div class="user-image">
                      <div id="image-preview" class="user-image-holder" :style="`background-image:url(${preview})`">
                        <input type="file" name="paymentslip" id="image-upload"  @change="uploadPaymentSlip"/>
                      </div>
                      <div class="user-images-detail">
                        <span class="size-hint"> ( 100 X 100 ) </span>
                        <label for="image-upload" class="btn btn-primary" id="image-label"> upload payment slip </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <button class="btn btn-primary float-right" id="submitForm" v-on:click="submitForm"> Submit</button>
                </div>

              </form>
            </div>
          </div>
        </div>

        <div v-if="viewPaymentSlips" class="tab-pane fade" id="history" role="tabpanel" aria-labelledby="history-tab">

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="label block-label"> From Date </label>
                <datepicker name="from_date" v-model="from_date" input-class="datepicker" :bootstrap-styling="true" placeholder="From Date"></datepicker>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="label block-label"> To Date </label>
                <datepicker name="to_date" v-model="to_date" input-class="datepicker" :bootstrap-styling="true" placeholder="To Date"></datepicker>
              </div>
            </div>
            <div class=" form-group col-md-12">
              <div class=" align-right">
                <br>
                <button @click="filterTable" class="btn btn-primary">Submit</button>
                <button @click="exportData" class="btn btn-primary">Export</button>
              </div>
            </div>
          </div>

          <table id="dt-history" class="table" style="width:100%">
            <thead>
            <tr>
              <th>Company</th>
              <th>Depositer</th>
              <th>Bank</th>
              <th>Deposit Date</th>
              <th>Via</th>
              <th>Amount </th>
              <th>Actions </th>
              <th>Comments </th>
              <th>DateTime </th>
              <th>Status</th>
            </tr>
            </thead>
          </table>
        </div>
      </div>
      <template>
        <div class="modal fade" id="absenteesModal" tabindex="-1" role="dialog" aria-labelledby="absenteesModalLabel" aria-hidden="true">
          <div style="width: 570px" class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <div class="modal-body abentess-popup pr-0 pt-4 pl-0 pt-3 pb-3">
                    <paymentDetail></paymentDetail>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>

</template>

<script>
var gThat = null;
var dtTable = null;
    export default {
        data() {
            return {
              s3BaseUrl:'',
              currentActiveTab:'upload',
              paymentSlips:false,
              from_date : '',
              to_date : '',
              viewPaymentSlips:false,
                form: new Form({
                amount:'',
                bank:'MEEZAN',
                paymentslip: '',
                deposit_date:'',
                via:'IBFT'
                }),
                preview:'',
                is_show_btn : true,
                is_show_inputs : false,
              fristload:true,
              isDataTableLoading:true,
            };
        },
        methods: {
            submitForm(){
                this.disableButton('submitForm','Submitting...',true);
                if(this.form.amount<1){
                           this.showAlertBox('error','Please fill in the mandatory fields.');
                           this.disableButton('submitForm','Submit',false);
                            return false;
                        }
              if(this.form.amount>99999999){
                this.showAlertBox('error','Amount limit exceeded!');
                this.disableButton('submitForm','Submit',false);
                return false;
              }
                this.$Progress.start();
                let form=new FormData();
                 form.append('paymentslip',this.form.paymentslip);
                 form.append('amount',this.form.amount);
                 form.append('bank',this.form.bank);
                 form.append('deposit_date',this.form.deposit_date);
                 form.append('via',this.form.via);

                axios.post('/api/savePaymentSlip',form)
                    .then(res => {
                        if(res.status == 200){
                            if(res.data.code == '200'){
                                 // $('#paymentInvoice')[0].reset();
                                 this.form.paymentslip = '';
                                 this.form.amount = '';
                                 this.form.bank = 'MEEZAN';
                                 this.form.deposit_date = '';
                                 this.form.via = 'IBFT';
                                 this.preview = '';
                                this.showToastBox('success', 'Payment Slip successfully uploaded.');
                                this.disableButton('submitForm','Submit',false);
                                this.$Progress.finish();
                            }else{
                                this.showAlertBox('error', res.data.msg);
                                this.disableButton('submitForm','Submit',false);
                                this.$Progress.finish();
                            }
                        }else{
                            this.$Progress.fail();
                            this.disableButton('submitForm','Submit',false);
                            this.showAlertBox('error','Some problem in you form data');
                        }
                    }).then(res=>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.disableButton('submitForm','Submit',false);
                        this.showAlertBox('error','Some problem in you form data');
                    });
            },

            // onImageChange(e){
            //     if(e.target.files[0] == undefined)
            //     {
            //         return;
            //     }
            //     this.form.paymentslip = e.target.files[0];
            //     this.uploadImage(e);
            // },
            // uploadImage(e) {
            //     e.preventDefault();
            //     const config = {
            //         headers: { 'content-type': 'multipart/form-data' }
            //     }
            //     let formData = new FormData();
            //     formData.append('paymentslip', this.form.paymentslip);
            //     axios.post('api/uploadPaymentSlip', formData, config)
            //         .then(res => {
            //             if(res.status == 200){
            //                 if(res.data.code == 200){
            //                     this.form.paymentslip = res.data.paymentslip;
            //                     console.log($global.aws_base_url+'paymentslip/'+this.form.paymentslip);
            //                     $('#user-profile-img').attr('src',$global.aws_base_url+'paymentslip/'+this.form.paymentslip);
            //                     this.showToastBox('success', 'Profile Image updated successfully');
            //                     this.$Progress.finish();
            //                 }else{
            //                     this.$Progress.fail();
            //                     this.showAlertBox('error','Error to update Image');
            //                 }
            //             }else{
            //                 this.$Progress.fail();
            //                 this.showAlertBox('error','Some problem in you form data');
            //             }
            //         })
            //         .catch(err => {
            //             this.$Progress.fail();
            //             this.showAlertBox('error','Some problem in you form data');
            //         });
            // },

            uploadPaymentSlip(e) {
                let self=this;
                    var files = e.target.files || e.dataTransfer.files;
                    if(files.length >0){

                        if((e.target.files[0].size/1024)>2048){
                            console.log(e.target.files[0].size)
                           this.showAlertBox('error','File is to large');
                            return false;
                        }

                        this.form.paymentslip=e.target.files[0];

                         var reader = new FileReader();
                        reader.onload = function (e) {
                            self.preview=e.target.result;
                            }
                              if(e.target.files[0].type=="application/pdf"){
                               self.preview='/pdf/pdf.png'
                            }else{
                                reader.readAsDataURL(e.target.files[0]);
                            }
                    }else{
                        this.form.paymentslip='';
                    }

             },
            showInputs(){
                this.is_show_btn = false;
                this.is_show_inputs = true;
            },
          reloadList(tabClicked){
            switch(tabClicked)
            {
              case 'upload':
                if(gThat.currentActiveTab !== 'upload')
                {
                  gThat.isDataTableLoading = false;
                  gThat.currentActiveTab = 'upload';
                }
                break;

              case 'history':
                if(gThat.currentActiveTab !== 'history')
                {
                  gThat.paymentInvoiceHistory();
                  gThat.isDataTableLoading = true;
                  gThat.currentActiveTab = 'history';
                }
                break;
            }
          },
          paymentInvoiceHistory(){
            console.log(window.location.origin+'/');
            self =this;
            this.datatable = $('#dt-history').DataTable({
              processing: true,
              serverSide: true,
              responsive: true,
              ordering: false,
              ajax: {
                'url': "api/listPaymentInvoice",
                'method': "post",
                "data": function (d) {
                  d.from_date = moment(gThat.from_date).format('YYYY-MM-DD');
                  d.to_date = moment(gThat.to_date).format('YYYY-MM-DD');
                  d.isExport = 0;
                },
              },

              columns: [
                {data:'company'},
                {data:'name'},
                {data:'bank'},
                {data:'deposit_date'},
                {data:'via'},
                {data:'amount' , render: $.fn.dataTable.render.number(',', '.', 0, '')},
                {render: function(data,type,full,row){
                  if (full['status'] != 'APPROVED'){
                    var $deleteButton = '<a href="javascript:void(0);" onClick="window.softDelete('+full['id']+')"  data-toggle="tooltip" data-placement="top" title="Delete" class="action edit"> <i class="fas fa-trash-alt"></i> </a>';
                  }else{
                    var $deleteButton = '';
                  }
                    return `<a href="${self.s3BaseUrl+full['image']}" target="_blank"><i class="far fa-eye"></i></a>`+$deleteButton;
                    // return `<a href="${window.location.origin+'/paymentslip/'+full['image']}" target="_blank">Preview</a>`
                  }},
                {data:'comment'},
                {data:'PaymentSlipDateTime'},
                {data:'status'},
              ],
              "drawCallback": function(settings) {
                if(self.fristload){
                  self.fristload=false;
                  var columnReason = self.datatable.column(8);
                  columnReason.visible(false);
                  self.isDataTableLoading = false;
                }

              }
            });
          },
          exportData: function(id){
            this.$Progress.start();
            var formData = {
              'from_date': moment(this.from_date).format('YYYY-MM-DD'),
              'to_date': moment(this.to_date).format('YYYY-MM-DD'),
              'isExport':1
            };
            axios.post('api/listPaymentInvoice',formData,{
              responseType: 'blob'
            })
                .then((response) => {
                  if(response.status == 200){
                    this.$Progress.finish();
                    const url = URL.createObjectURL(new Blob([response.data], {
                      type: 'application/vnd.ms-excel'
                    }))

                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'payment_slip_history.xlsx')
                    document.body.appendChild(link)
                    link.click()
                    this.$Progress.finish();
                  }else{
                    this.showAlertBox('error','There is some problem');
                  }

                }).catch(err => {
              console.log(err);
              this.$Progress.fail();
              this.showAlertBox('error','There is some problem');
            });
          },
          filterTable(){
            this.$Progress.start();
            this.datatable.draw();
            this.$Progress.finish();
          },
          getCounts(){
            let self=this;
            axios.get('api/getPaymentSlipsCount')
                    .then(function(res){
                      console.log(res);
                      self.s3BaseUrl      = res.data.s3BaseUrl;
                    })
          },
          softDelete(id) {
            Swal.fire({
              title: 'Are you sure?',
              text: "You want to delete this!",
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
              if (result.value) {
                axios.post("/api/softDeletePaymentSlip", {id: id})
                        .then(res => {
                          if(res.status == 200){
                            this.showToastBox('success','record deleted successfully!');
                            this.$router.go(this.$router.currentRoute);
                            this.$Progress.finish();
                          }else{
                            this.$Progress.fail();
                            Swal.fire({
                              icon: 'error',
                              title: 'Oops...',
                              text: 'Something went wrong!',
                            })
                          }
                        })
                        .catch(err => {
                          console.log(err);
                          this.$Progress.fail();
                          this.showAlertBox('error','couldnt perform requested action');
                        });
              }
            })
          }
        },
        mounted() {
          gThat = this;
          this.can('upload_payment_invoice').then(result => {
            this.paymentSlips = result.upload_payment_invoice;
          });
          this.can('history_payment_invoice').then(result => {
            this.viewPaymentSlips = result.history_payment_invoice;
            if(this.viewPaymentSlips){
              this.getCounts();
              this.paymentInvoiceHistory();
            }
          });
          $(this.$el).find('.selectpicker').selectpicker('refresh');
          window.softDelete = function(id){
            gThat.softDelete(id);
          }
        },
    }
</script>
